import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const SaveToPdfPage: React.FC = () => {
  const printRef = useRef<HTMLDivElement>(null);

  const handleDownloadPdf = async () => {
    const element = printRef.current;
    if (!element) return;

    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * pageWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save("section.pdf");
  };

  return (
    <div>
      <button onClick={handleDownloadPdf}>Save to PDF</button>

      <div
        id="pdf-section"
        ref={printRef}
        style={{
          padding: "20px",
          marginTop: "20px",
          border: "1px solid #ccc",
          background: "#f9f9f9",
        }}
      >
        <h1>Invoice #12345</h1>
        <p>Date: 2025-09-23</p>
        <p>Client: John Doe</p>
        <p>Total: $500</p>
      </div>
    </div>
  );
};

export default SaveToPdfPage;
